import React from 'react';
import { ChangeOrderDashboard as ChangeOrderDashboardComponent } from 'components/app/crm/dashboard/change-order';

const ChangeOrderDashboardPage = () => {
  return <ChangeOrderDashboardComponent />;
};

export default ChangeOrderDashboardPage;